import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { select, Store } from '@ngrx/store';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountConsolidationInterface } from '../../../models/account-consolidation.interface';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { CustomerInterfaceState } from '../../../../account/store/state/customer.state';
import { CustomerInterface } from '../../../../account/models/customer.interface';
import { SaveCustomerMission, UpdateCustomerMission } from '../../../store/actions/customer-mission.actions';
import { CustomerService } from '../../../../account/services/customer.service';
import { AlertMessageInterface } from '../../../models/alert-message.interface';
import { GetAlertMessage } from '../../../store/actions/alert-message.actions';

@Component({
    selector: 'app-account-consolidation',
    templateUrl: './account-consolidation.component.html',
    styleUrls: ['./account-consolidation.component.css'],
    standalone: false
})
export class AccountConsolidationComponent implements OnInit {

  @Input()
  procedureCode: string;

  @Input()
  step: number;

  @Input()
  message: any;

  @Input()
  status: string;

  customer: CustomerInterface;
  customerForm: FormGroup;
  customerFormSubmitted: boolean;

  constructor(
      private store: Store<any>,
      private formBuilder: FormBuilder,
      private customerService: CustomerService
  ) {}

  ngOnInit() {
      this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER)).subscribe( (result: CustomerInterfaceState) => {
          if (null != result.customer) {
              this.customer = result.customer;
          }
      });
      this.customerFormSubmitted = false;
      this.initCustomerForm();
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  save() {
    if (this.customerForm.valid && this.customerFormSubmitted === false) {
        const alertMessage = {message: 'Les informations du compte client sont invalides', code: 400} as AlertMessageInterface;
        if (this.customerForm.get('id').value === this.customer.id) {
            this.customerFormSubmitted = true;
            this.store.dispatch(new GetAlertMessage(alertMessage));
        } else {
            this.customerService.checkAccountConsolidation(this.customerForm.get('id').value, this.customerForm.get('lastName').value).subscribe(
                response => {
                    this.customerFormSubmitted = true;
                    const accountConsolidationInterface = {
                        step: 1,
                        externalId: this.customerForm.get('id').value.toString(),
                        destinationAccount: this.customerForm.get('id').value,
                        customerId: this.customer.id,
                        response: null,
                    };
                    this.store.dispatch(new SaveCustomerMission(accountConsolidationInterface, this.procedureCode, 'account'));
                },
                error => {
                    this.store.dispatch(new GetAlertMessage(alertMessage));
                }
            );
        }
    }
  }

  attachAccount(response: boolean) {
      if (this.customerFormSubmitted === false) {
          const accountConsolidationInterface = {
              step: 1,
              externalId: this.message.data.src_account,
              destinationAccount: this.message.data.src_account,
              customerId: this.customer.id,
              response
          } as AccountConsolidationInterface;
          this.customerFormSubmitted = true;
          this.store.dispatch(new UpdateCustomerMission(accountConsolidationInterface, this.procedureCode, 'account'));
      }
  }

  /**
   * Init customer form
   */
  initCustomerForm() {
    this.customerForm = this.formBuilder.group({});
    this.customerForm.addControl('id', this.formBuilder.control('', [Validators.required]));
    this.customerForm.addControl('lastName', this.formBuilder.control('', [Validators.required]));
  }
}
